import { Building2, Check, Loader2 } from 'lucide-react';
import { Button, Description, Modal, type OverlayTriggerState } from '@heroui/react';
import type { Condominium } from '../../api/condominiums';

interface SwitchCondominiumModalProps {
  state: OverlayTriggerState;
  condominiums: Condominium[];
  selectedCondominiumId?: string;
  switching?: boolean;
  onSelect: (slug: string) => void | Promise<void>;
}

export function SwitchCondominiumModal({
  state,
  condominiums,
  selectedCondominiumId,
  switching = false,
  onSelect,
}: SwitchCondominiumModalProps) {
  return (
    <Modal state={state}>
      <Modal.Backdrop isDismissable={!switching} className="z-[200]">
        <Modal.Container placement="center" className="z-[200]">
          <Modal.Dialog className="w-full max-w-md overflow-hidden">
            <Modal.Header className="border-b border-separator pb-4">
              <div className="flex flex-col gap-1 pr-8">
                <Modal.Heading>Trocar condomínio</Modal.Heading>
                <Description>
                  Escolha o condomínio ativo. Vagas, solicitações e dados exibidos passam a ser
                  deste tenant.
                </Description>
              </div>
              <Modal.CloseTrigger />
            </Modal.Header>

            <Modal.Body className="flex flex-col gap-2 py-4">
              {condominiums.map((item) => {
                const isSelected = selectedCondominiumId === item.id;
                const isLoadingThis = switching && isSelected;

                return (
                  <button
                    key={item.id}
                    type="button"
                    disabled={switching}
                    onClick={() => void onSelect(item.slug)}
                    className={[
                      'flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-left transition-colors',
                      'disabled:cursor-not-allowed disabled:opacity-70',
                      isSelected
                        ? 'border-accent bg-accent/10 ring-1 ring-accent/30'
                        : 'border-separator bg-surface-secondary hover:border-accent/40 hover:bg-surface-tertiary',
                    ].join(' ')}
                  >
                    <div
                      className={[
                        'flex size-10 shrink-0 items-center justify-center rounded-lg',
                        isSelected ? 'bg-accent text-accent-foreground' : 'bg-surface text-muted',
                      ].join(' ')}
                    >
                      <Building2 size={18} />
                    </div>

                    <div className="min-w-0 flex-1">
                      <p className="truncate font-medium text-foreground">{item.name}</p>
                      <p className="truncate text-xs text-muted">@{item.slug}</p>
                    </div>

                    <div className="flex size-6 shrink-0 items-center justify-center">
                      {isLoadingThis ? (
                        <Loader2 size={18} className="animate-spin text-accent" />
                      ) : isSelected ? (
                        <span className="flex size-6 items-center justify-center rounded-full bg-accent text-accent-foreground">
                          <Check size={14} strokeWidth={3} />
                        </span>
                      ) : (
                        <span className="size-6 rounded-full border border-separator" aria-hidden />
                      )}
                    </div>
                  </button>
                );
              })}
            </Modal.Body>

            <Modal.Footer className="flex justify-end gap-2 border-t border-separator">
              <Button variant="ghost" isDisabled={switching} onPress={state.close}>
                Cancelar
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
